import styled from 'styled-components';

export const StyledUploadModal = styled.div`
`;

export const UploadModalContent = styled.div`
  display: flex;
  height: 30rem;
`;

export const RemoveButton = styled.div`
  position: absolute;
  z-index: 101;
  top: 1rem;
  right: 1rem;
  cursor: pointer;

  img {
    width: 1.5rem;
    height: 1.5rem;
    transition: scale linear 0.2s;
  }
  img:hover {
    scale: 1.2;
  }
`;

export const UploadSection = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-left: ${({ $hasLeftBorder }) => $hasLeftBorder ? 'solid' : 'none'} ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};

  .upload-section-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
  }

  .upload-section-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .upload-section-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .upload-section-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .upload-section-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  .upload-modal-file-uploader {
    display: block;
    min-width: 20rem;
    max-width: 20rem;
    height: 100%;
  }

  .upload-modal-portrait-uploader {
    min-width: 20rem;
    min-height: 20rem;
    max-width: 20rem;
    max-height: 20rem;
  }

  .upload-modal-button-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const PotrtaitAndName = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${({ theme }) => theme.brightBlue};
`;

export const Portrait = styled.div`
  min-width: 20rem;
  min-height: 20rem;
  max-width: 20rem;
  max-height: 20rem;
  position: relative;
  z-index: 99;
`;

export const PopupControls = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 100;
  gap: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  flex-direction: column;
  justify-content: center;
  position: relative;
  background: ${({ theme }) => theme.background};
  border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => 'white'};
`;

export const DropOrUpload = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 0.2);
  font-family: "BebasNeue";
  font-size: 3rem;
  font-weight: 700;
  max-width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
`
